import { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, Timestamp, doc, updateDoc, getDocs } from 'firebase/firestore';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import './style.css'

export default function Home() {
  const [data, setData] = useState({
    fajr : 0,
    zohar: 0,
    asr: 0,
    magrib: 0,
    isha: 0,
    witr: 0
});

const [recordId, setRecordId] = useState(null)


const navigate = useNavigate()

const user = useSelector((state) => state.user.userInfo);

  const[dateToBeComplete, setDateToBeComplete] = useState(Date())
useEffect(()=>{
  if(user==null){
    navigate("/login")
  }else{
    initializeRecord()
  }

  

},[])

const resetToZero = async () => {

  let isConfirm = window.confirm("Do you realy want to reset to zero?"+recordId)

  if(!isConfirm){
    return false;
  }

  try{

    var _data = {
      fajr : 0,
      zohar: 0,
      asr: 0,
      magrib: 0,
      isha: 0,
      witr: 0
  }

    if(data==null || recordId == null){

      const docRef = await addDoc(collection(db, 'qazaa_namaaz',user.user.uid+'/db'), {
        ..._data,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now()
      });

      console.log("Document written with ID: ", docRef.id);

    }else{

      const documentRef = doc(db, 'qazaa_namaaz', user.user.uid+'/db/'+recordId);
      try {
        await updateDoc(documentRef, {
          ..._data,
          updatedAt: Timestamp.now()
        });
        console.log('Document updated successfully!');
      } catch (error) {
        console.error('Error updating document:', error);
      }

    }
  }catch(e){
      
  }

  initializeRecord()

}

const initializeRecord = async () => {

    const querySnapshot = await getDocs(collection(db, 'qazaa_namaaz',user.user.uid+'/db'));
    const dataArr = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
    }));

    let _data = dataArr[0]

    if(_data!=null){

      setRecordId(_data.id)

      _data = Object.fromEntries(
        
        Object.entries(_data).map(([key, value]) => [key, parseInt(value, 10)])
        .filter(([key, value]) => !Number.isNaN(value))
      );

      setData(_data)

      console.info(_data)

      let maxDays = Math.max(...Object.values(_data));
      console.info("Max Days :: ",maxDays)
      var now = moment();
      var futureDate = now.add(maxDays, 'days');
      setDateToBeComplete(futureDate)

    }
    
}

const calculateDays = (days) => {

  const duration = moment.duration(days, 'days');

  // Convert to years, months, days
  const years = Math.floor(duration.asYears());
  const months = duration.months(); // Remaining months
  const remainingDays = duration.days(); // Remaining days

   return `${years} years, ${months} months, ${remainingDays} days`

}

  return (
    <div className="p-4">
      <h1>Qazaa Namaaz Tracker</h1>

      
      <h2 className="text-xl font-bold mb-2">Total Remaining Namaaz</h2>

      <table className="table-auto border-collapse w-full border table-bordered">
        <thead>
          <tr>
            <th className="border p-2">Namaaz</th>
            <th className="border p-2">Days</th>
            <th className="border p-2">Raqaat</th>
          </tr>
        </thead>
        <tbody>
            <tr>
              <td className="border p-2">Fajr</td>
              <td className="border p-2">{calculateDays(data.fajr)}</td>
              <td className="border p-2">{data.fajr*2}</td>
            </tr>
            <tr>
              <td className="border p-2">Zohar</td>
              <td className="border p-2">{calculateDays(data.zohar)}</td>
              <td className="border p-2">{data.zohar*4}</td>
            </tr>
            <tr>
              <td className="border p-2">Asr</td>
              <td className="border p-2">{calculateDays(data.asr)}</td>
              <td className="border p-2">{data.asr*4}</td>
            </tr>
            <tr>
              <td className="border p-2">Magrib</td>
              <td className="border p-2">{calculateDays(data.magrib)}</td>
              <td className="border p-2">{data.magrib * 3}</td>
            </tr>
            <tr>
              <td className="border p-2">Isha</td>
              <td className="border p-2">{calculateDays(data.isha)}</td>
              <td className="border p-2">{data.isha * 4}</td>
            </tr>
            <tr>
              <td className="border p-2">Witr</td>
              <td className="border p-2">{calculateDays(data.witr)}</td>
              <td className="border p-2">{data.witr * 3}</td>
            </tr>
          
        </tbody>
      </table>

      <p>If you perform 5 daily Qazaa prayers including Witr — one each of Fajr, Zuhr, Asr, Isha, and Witr, totaling 20 Rakaats — you will complete your Qazaa by {moment(dateToBeComplete).format('DD MMM yyyy')}.</p>

      <Link to="/add">
        <button className="bg-green-500 text-white p-2 mt-4">Add Namaaz</button>
      </Link><br></br><br></br><Link to="/init">
        <button className="bg-green-500 text-white p-2 mt-4">Initialize</button>
      </Link>
      <br></br><br></br>
      <button className="bg-green-500 text-white p-2 mt-4" onClick={resetToZero}>Reset to zero</button>
    </div>
  );
}